import { Injectable } from '@angular/core';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Injectable({
  providedIn: 'root'
})
export class SweetAlertService {

  constructor() { }

  alertWithSuccess(title?, message?, status?): void {
    Swal.fire(title, message, status);
  }

  alertWithMessage(message?): void {
    Swal.fire(message);
  }
}
